module.exports = __webpack_public_path__ + "static/media/blank_canvas.1a2f540d.svg";